import React from 'react';
import { MapPin, Heart, Code2 } from 'lucide-react';
import './About.css';

const team = [
    {
        name: 'Lucas Almquist',
        role: 'Webbutvecklare & Designer',
        desc: 'Specialist på att bygga snabba, moderna hemsidor som konverterar besökare till kunder. Ansvarar för all kod och design.'
    },
    {
        name: 'Hanna Almquist',
        role: 'Kundansvarig',
        desc: 'Ser till att din vision blir verklighet och att du känner dig trygg genom hela processen. Din kontaktperson från start till mål.'
    },
    {
        name: 'Oliver Almquist',
        role: 'Kundansvarig',
        desc: 'Dedikerad till att ge våra kunder den bästa möjliga upplevelsen och se till att varje projekt levereras med högsta kvalitet.'
    }
];

export default function About() {
    return (
        <section className="about" id="about">
            <div className="container">
                <div className="about-content">
                    <div className="about-text">
                        <span className="section-eyebrow">Om oss</span>
                        <h2 className="section-title">Mer än bara kod</h2>
                        <p className="lead">
                            Vi är en webbyrå med rötterna i <strong>Falun, Dalarna</strong>.
                            Vi kombinerar teknisk expertis med en genuin vilja att hjälpa lokala företag att växa.
                        </p>
                        <p>
                            För oss handlar webbdesign inte bara om ettor och nollor. Det handlar om relationer.
                            Vi tror på långsiktiga samarbeten där vi lär känna din verksamhet på djupet.
                            Genom att vara lokalt förankrade kan vi erbjuda en personlig service och snabb support som gör skillnad.
                        </p>
                        <div className="stats-grid">
                            <div className="stat-item">
                                <MapPin className="stat-icon" size={18} />
                                <span>Baserade i Falun</span>
                            </div>
                            <div className="stat-item">
                                <Heart className="stat-icon" size={18} />
                                <span>Kundfokus</span>
                            </div>
                            <div className="stat-item">
                                <Code2 className="stat-icon" size={18} />
                                <span>Modern teknik</span>
                            </div>
                        </div>
                    </div>
                    <div className="about-photo">
                        <img
                            src="/images/portfolio/team.webp"
                            alt="Lucas, Hanna och Oliver – teamet bakom Briljans"
                            loading="lazy"
                            width="1200"
                            height="800"
                        />
                    </div>
                </div>

                <div className="team-section">
                    <h3 className="team-title">Vilka är vi?</h3>
                    <p className="team-intro">
                        Vi brinner för att hjälpa företag att synas. Med en kombination av teknisk
                        spetskompetens och strategiskt tänkande skapar vi lösningar som fungerar på riktigt.
                    </p>
                    <div className="team-list">
                        {team.map((member) => (
                            <div className="team-member" key={member.name}>
                                <h4>{member.name}</h4>
                                <span className="role">{member.role}</span>
                                <p>{member.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
